import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from '../../i18n';

const StrengthDetailsForm = ({
  title, setTitle, description, setDescription,
  preComments, setPreComments, postComments, setPostComments
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Form.Group controlId="formTitle" className="mb-2">
        <Form.Label>{t('activityDetails.titleLabel')}</Form.Label>
        <Form.Control plaintext readOnly value={title || t('activityDetails.untitled')} className="fw-bold text-primary" />
      </Form.Group>
      <Form.Group controlId="formDescription" className="mb-2">
        <Form.Label>{t('activityDetails.descriptionLabel')}</Form.Label>
        <Form.Control as="textarea" rows={2} value={description || ''} onChange={(e) => setDescription(e.target.value)} placeholder={t('activityDetails.descriptionPlaceholder')} />
      </Form.Group>
      <Form.Group controlId="formPreComments" className="mb-2">
        <Form.Label>{t('activityDetails.preComments')}</Form.Label>
        <Form.Control as="textarea" rows={2} value={preComments || ''} onChange={(e) => setPreComments(e.target.value)} />
      </Form.Group>
      <Form.Group controlId="formPostComments">
        <Form.Label>{t('activityDetails.postComments')}</Form.Label>
        <Form.Control as="textarea" rows={2} value={postComments || ''} onChange={(e) => setPostComments(e.target.value)} />
      </Form.Group>
    </>
  );
};

export default StrengthDetailsForm;
